import { render } from "./PostEdit.vue?vue&type=template&id=ebd3c688&scoped=true"
import script from "./PostEdit.vue?vue&type=script&lang=js"
export * from "./PostEdit.vue?vue&type=script&lang=js"

import "./PostEdit.vue?vue&type=style&index=0&id=ebd3c688&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebd3c688"]])

export default __exports__